/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { instanceOfFxIdDomainSettingsTwitchAuthOptions, FxIdDomainSettingsTwitchAuthOptionsFromJSONTyped, FxIdDomainSettingsTwitchAuthOptionsToJSON, } from './FxIdDomainSettingsTwitchAuthOptions';
export function FxIdDomainSettingsPublicWebClientConfigOptionsAuthConfigTwitchFromJSON(json) {
    return FxIdDomainSettingsPublicWebClientConfigOptionsAuthConfigTwitchFromJSONTyped(json, false);
}
export function FxIdDomainSettingsPublicWebClientConfigOptionsAuthConfigTwitchFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdDomainSettingsTwitchAuthOptions(json)) {
        return FxIdDomainSettingsTwitchAuthOptionsFromJSONTyped(json, true);
    }
    return {};
}
export function FxIdDomainSettingsPublicWebClientConfigOptionsAuthConfigTwitchToJSON(json) {
    return FxIdDomainSettingsPublicWebClientConfigOptionsAuthConfigTwitchToJSONTyped(json, false);
}
export function FxIdDomainSettingsPublicWebClientConfigOptionsAuthConfigTwitchToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    if (instanceOfFxIdDomainSettingsTwitchAuthOptions(value)) {
        return FxIdDomainSettingsTwitchAuthOptionsToJSON(value);
    }
    return {};
}
//# sourceMappingURL=FxIdDomainSettingsPublicWebClientConfigOptionsAuthConfigTwitch.js.map